import Vue from "vue";
import Captcha from "@/components/Captcha";

Vue.component(Captcha.name, Captcha);
